import React from 'react'

const GameRules = () => {
    return (
        <>
            <div className="game-rule text-center">
                <h1>Game Rules</h1>
            </div>
            <div className="container" id='game-rule'>
                <section className="p-5 howPlay">
                    <div className="container">
                        <div className="container-fluid mx-5">
                            <h4>Withdraw Information</h4>
                            <ul>
                                <li className='mb-2'>If Users Entered Wrong Bank Details STAR123 Is Not Responsible.</li>
                                <li className='mb-2'>Before Requesting Withdraw Re-check Your Bank Details.</li>
                                <li>After Withdraw Request If There Is No Vaild Wallet Balance The Request Will Be Auto Declined.</li>
                            </ul>

                            <h4>Unfair - Bets</h4>
                            <p>If Admin Found Any Unfair-bets, Blocking Of Digits, Canning Or Match Fix Bets. Admin Has All Rights To Take Necessary Actions To Block The User.</p>
                            
                            <h4>Cheating - Bets</h4>
                            <p>If Admin Found Any Cheating, Hacking, Phishing. Admin Has All Rights To Take Necessary Actions To Block The User.</p>

                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default GameRules;
